"use strict";

exports.__esModule = true;
exports.extractMentionsFromContent = exports.getMentionsFromEditorState = exports.createSiteMembersFetchService = void 0;

var createSiteMembersFetchService = function createSiteMembersFetchService(_ref) {
  var instance = _ref.instance,
      apiBaseUrl = _ref.apiBaseUrl;
  return function (query) {
    return fetch(apiBaseUrl + "mentions?query=" + query, {
      method: 'GET',
      headers: {
        Authorization: instance,
        'Content-Type': 'application/json',
        instance: instance
      }
    }).then(function (response) {
      var status = response.status;

      if (status < 400) {
        return response.json()["catch"](function () {
          return Promise.resolve();
        });
      }

      return Promise.reject(response);
    }).then(function (profiles) {
      return profiles.map(function (p) {
        return {
          name: p.nickname,
          slug: p.slug,
          avatar: p.imageUrl,
          id: p.id
        };
      });
    });
  };
};

exports.createSiteMembersFetchService = createSiteMembersFetchService;

var getMentionsFromEditorState = function getMentionsFromEditorState(editorState) {
  if (!editorState || !editorState.entityMap) {
    return [];
  }

  return Object.values(editorState.entityMap).filter(function (entity) {
    return entity.type === 'mention';
  }).map(function (entity) {
    return entity.data.mention;
  });
};

exports.getMentionsFromEditorState = getMentionsFromEditorState;

var extractMentionsFromContent = function extractMentionsFromContent(content) {
  return getMentionsFromEditorState(content).map(function (item) {
    return item.id;
  });
};

exports.extractMentionsFromContent = extractMentionsFromContent;